<ng-container *transloco="let t">
  @if (hasNoData()) {
    <div class="flex gap-1">
      {{ t("profit-and-loss.no_data_for_marketplace") }}
    </div>
  } @else {
    <div class="rounded-lg border p-4">
      <div class="mb-2 text-right">
        <app-export-button (export)="downloadFile()" tooltipValue="{{ t('common.export_as_csv') }}"></app-export-button>
      </div>

      <table class="w-full table-fixed items-center">
        <thead class="text-slate-500">
          <tr class="border-b border-gray-300">
            <th class="px-4 py-[0.75rem] text-left text-sm text-gray-700">
              {{ t("profit-and-loss.pl_in_currency", [currency()]) }}
            </th>
            @for (th of months(); track $index) {
              <th class="w-1/15 px-4 py-[0.75rem] text-right text-sm text-gray-700">{{ th }}</th>
            }
          </tr>
        </thead>
        <tbody class="text-gray-800">
          @for (row of this.rows(); track $index) {
            @if (!row.empty) {
              <tr class="border-b border-gray-200">
                @if (row.expand !== undefined) {
                  <td class="flex items-center px-[0.3rem] text-sm whitespace-normal">
                    <a (click)="expandRow(row.label)" class="text-main-500 cursor-pointer p-2">
                      <IIcon [name]="row.expand ? 'minus' : 'plus'" />
                    </a>
                    <span>{{ t(row.label) }}</span>
                    @if (row.tooltip) {
                      <IIcon name="infoCircle" class="ml-1" [iTooltip]="row.tooltip" />
                    }
                  </td>
                } @else {
                  <td class="px-4 py-3 text-sm whitespace-normal">
                    <span>{{ t(row.label) }}</span>
                    @if (row.tooltip) {
                      <IIcon name="infoCircle" class="ml-1" [iTooltip]="row.tooltip" />
                    }
                  </td>
                }
                @for (value of row.values; track $index) {
                  <td class="px-4 py-[0.6rem] text-right text-sm">{{ value }}</td>
                }
              </tr>
              @if (row.expand) {
                @for (expandedRow of row.rows; track $index) {
                  @if (!expandedRow.empty) {
                    <tr class="border-b border-gray-200">
                      <td class="relative pl-5">
                        <div class="relative flex items-stretch">
                          <div class="w-[0.3rem] bg-emerald-500"></div>

                          <span class="py-1.75 pl-2 text-sm leading-snug">
                            {{ t(expandedRow.label) }}
                            @if (expandedRow.tooltip) {
                              <IIcon name="infoCircle" class="ml-1" [iTooltip]="expandedRow.tooltip" />
                            }
                          </span>
                        </div>
                      </td>
                      @for (value of expandedRow.values; track $index) {
                        <td class="py-0.2 px-4 text-right text-sm">{{ value }}</td>
                      }
                    </tr>
                  }
                }
              }
            }
          }
        </tbody>
      </table>
    </div>
  }
</ng-container>
